import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { color, borderColor, px } from 'styled-system';
export var applyFocus = function applyFocus(props, defaultStyle) {
  return {
    ':focus': props.focusStyle ? _objectSpread({}, props.focusStyle) : defaultStyle(props)
  };
};
export var applyFocusVisible = function applyFocusVisible(props, defaultStyle, defaultFocusStyle) {
  return {
    ':focus-visible': props.focusVisibleStyle ? _objectSpread({}, props.focusVisibleStyle) : defaultStyle(props),
    ':focus:not(:focus-visible)': props.focusStyle ? _objectSpread({}, props.focusStyle) : defaultFocusStyle(props)
  };
};
export var appleFocusWithin = function appleFocusWithin(props, defaultStyle) {
  return {
    ':focus-within': props.focusWithinStyle ? _objectSpread({}, props.focusWithinStyle) : defaultStyle(props)
  };
};
export var focusNoOutline = function focusNoOutline() {
  return {
    outline: 'none'
  };
};
export var focusOutline = function focusOutline(props) {
  return {
    outline: props.outline ? props.outline : "3px solid ".concat(props.theme.colors.focus),
    outlineOffset: '1px'
  };
};
export var focusOutlinePadding = px(4);
export var focusStyle = function focusStyle(props) {
  return applyFocus(props, focusOutline);
};
export var focusVisibleStyle = function focusVisibleStyle(props) {
  return applyFocusVisible(props, focusOutline, focusNoOutline);
};
export var focusWithinStyle = function focusWithinStyle(props) {
  return appleFocusWithin(props, focusOutline);
};
export var focusFieldOutline = function focusFieldOutline(props) {
  return {
    outline: 'none',
    boxShadow: "0px 0px 0px 3px ".concat(props.theme.colors[props.theme.formField.boxShadowColor] || props.theme.formField.boxShadowColor),
    border: "1px solid ".concat(props.theme.colors[props.theme.formField.borderColor] || props.theme.formField.borderColor)
  };
};
export var focusFieldOutlineProps = function focusFieldOutlineProps(props) {
  return {
    focusOutline: 'none',
    focusBoxShadow: "0px 0px 0px 3px ".concat(props.theme.colors[props.theme.formField.boxShadowColor] || props.theme.formField.boxShadowColor),
    focusBorder: "1px solid ".concat(props.theme.colors[props.theme.formField.borderColor] || props.theme.formField.borderColor)
  };
};
export var focusFieldStyle = function focusFieldStyle(props) {
  return applyFocusVisible(props, focusFieldOutline, focusNoOutline);
};
export var focusWithinFieldStyle = function focusWithinFieldStyle(props) {
  return appleFocusWithin(props, focusFieldOutline);
};
export var remapHoverProps = function remapHoverProps(props) {
  return {
    color: props.hoverColor,
    bg: props.hoverBg,
    borderColor: props.hoverBorderColor,
    theme: props.theme
  };
};
remapHoverProps.propTypes = {
  hoverColor: color.propTypes.color,
  hoverBg: color.propTypes.bg,
  hoverBorderColor: borderColor.propTypes.borderColor
};
export var hoverFocus = function hoverFocus(css) {
  return css && Object.keys(css).length ? {
    '&:hover, &:focus': css
  } : {};
};
export var wrapWithFocus = function wrapWithFocus(css) {
  return css && Object.keys(css).length ? {
    '&:focus': css
  } : {};
};
export var getFocusable = function getFocusable(el) {
  return el.querySelector('button,a,input,select,textarea,[tabindex]');
};
export var focusOnFocusable = function focusOnFocusable(el) {
  if (el) {
    var focusable = getFocusable(el);

    if (focusable) {
      focusable.focus();
    }
  }
};